import React from 'react';
import './App.css';
import ReactDOM from 'react-dom';
import { useState } from 'react';


var theIndex = 0;

class App extends React.Component {
  constructor(props) {
    theIndex = theIndex + 1
    super(props);
    this.theindex = theIndex
    this.state = {
      pokemonName: "",
      newpokemonName: "",
      pokemon: [],
      count: -1,
      status: "empty",
      updatestatus: "empty"
    };
    this.baseUrl = "https://pokeapi.co/api/v2/pokemon";
    // We need to bind `this`, more details here: https://reactjs.org/docs/faq-functions.html
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUpdateChange = this.handleUpdateChange.bind(this);
    this.updatePokemon = this.updatePokemon.bind(this);
  }
  
  handleSubmit(event) {
    event.preventDefault();
    fetch(`${this.baseUrl}/${this.state.pokemonName}`)
      .then((body) => body.json())
      .then((pokemon) => {
        console.log(pokemon);
        // We use the ES6 spread operator ("...") to spread the items already in state
        // and append the new Pokemon from the fetch request to the end of the array
        this.setState({ pokemon: [...this.state.pokemon, pokemon] });
        this.setState({count: this.state.count + 1 });
      });
    this.setState( {newpokemonName: ""});
    this.setState({ pokemonName: "" });
    theIndex = theIndex + 1;
    this.setState({status: "empty"})
  }

  updatePokemon(event, index) {
    event.preventDefault();
    fetch(`${this.baseUrl}/${this.state.newpokemonName}`)
      .then((body) => body.json())
      .then((data) => {
        console.log(data);
        let pokemon = [...this.state.pokemon];   
        pokemon[index] = data;              
        this.setState({ pokemon }); 
      });
    this.setState( {newpokemonName: ""});
    this.setState({ pokemonName: "" });
    this.setState({updatestatus: "empty"})
  }

  handleChange(event) {
    this.setState({ pokemonName: event.target.value });
    this.setState({status: "sucess"})
  }

  handleUpdateChange(event) {
    this.setState({ newpokemonName: event.target.value });
    this.setState({updatestatus: "sucess"})
  }  

  render() {
    return (
      <body>
        <h1> Pokemon Cards! </h1>
        <h2> (type in any pokemon name to get its card!) </h2>
          <form class = "form1" onSubmit={this.handleSubmit}>
            <input
              type="text"
              value={this.state.pokemonName}
              onChange={this.handleChange}
            />
            <button type="submit"
            disabled={this.state.status === 'empty'}
            >Add Pokemon
            </button>
          </form>
        <div>
          <div class = "container"> 
            {/* For each Pokemon in state, we'll render the corresponding card */}
            {/* The `key` prop/attribute helps React identify what's changed and what hasn't */}
            {this.state.pokemon.map((pokemon, count) => (
              <div class = "container2">
             <MakePokemonCard key={pokemon.id} pokemon={pokemon} name={pokemon.name} index={this.state.count}/>
             <form onSubmit = {(e, count1) => this.updatePokemon(e, count)} class = "form1">
              <input 
              type = "text"
              deafaultValue = ""
              onChange={this.handleUpdateChange}/>
               <button 
               type="submit"
               disabled={this.state.updatestatus === 'empty'}>
                Update
            </button>
             </form>
           
           </div>
            ))}
          </div>
        </div>
      </body>
    );
  }
}


class MakePokemonCard extends React.Component {
  
  constructor(props) {
    super(props);
    this.baseUrlColor = "https://pokeapi.co/api/v2/pokemon-species"
    this.state = {
      color: "",
    };
  }

  getColor(name){
    fetch(`${this.baseUrlColor}/${name}`)
      .then((body) => body.json())
      .then((data) => {
        console.log(data);
        this.setState({color: data.color.name})
      });

  }


  render() {
    this.getColor(this.props.pokemon.name)
    return (
      <div class="card" style = {{'background-image': `linear-gradient(${this.state.color}, white)`}}>
        <p class="title">
          {this.props.pokemon.name} - {this.props.pokemon.id}
        </p>
        <img
          src={this.props.pokemon.sprites.other.dream_world.front_default}
          alt={`${this.props.pokemon.name}`}
        />
        <p class = "ab">ABILITIES: {this.props.pokemon.abilities.map(ability => ability.ability.name)}</p>
        <p class = "ab"> XP: {this.props.pokemon.base_experience}</p>
        <p class = "ab"> WEIGHT: {this.props.pokemon.weight}   HEIGHT: {this.props.pokemon.height}</p>
      </div>
    );
  }
}

export default function Profile() {
  return (
    <div><App/> </div>
  );
}
